import greenTheme from './themes/green';
import darkTheme from './themes/dark';

const themes = {
  green: greenTheme,
  dark: darkTheme
};

// This will be overridden by dynamic theme selection
let currentTheme = 'dark';

// Set the active theme - this will be called from App.js when user data loads
export const setActiveTheme = (themeName) => {
  if (themes[themeName]) {
    currentTheme = themeName;
  }
};

export const getTheme = (themeName = currentTheme) => themes[themeName];

export const availableThemes = Object.keys(themes);

// Export the current theme - this will always return the active theme
const themeProxy = new Proxy({}, {
  get(target, prop) {
    // Ensure we have themes loaded
    if (!themes || Object.keys(themes).length === 0) {
      console.error('No themes loaded!', { themes, currentTheme });
      return undefined;
    }
    
    const activeTheme = themes[currentTheme];
    if (!activeTheme) {
      console.error(`Theme '${currentTheme}' not found. Available themes:`, Object.keys(themes));
      console.error('Themes object:', themes);
      // Fallback to first available theme
      const fallbackTheme = themes.dark || themes[Object.keys(themes)[0]];
      console.warn('Using fallback theme:', fallbackTheme ? 'found' : 'not found');
      return fallbackTheme?.[prop];
    }
    
    const result = activeTheme[prop];
    if (prop === 'colors' && !result) {
      console.error(`Theme '${currentTheme}' missing colors property!`, activeTheme);
    }
    return result;
  }
});

export default themeProxy;